import { filter, isEmpty } from 'lodash'
import { createSelector } from 'reselect'

import { transformedPendingRefundState } from 'utils/PendingRefunds'

export const getRefundOrders = (state) =>
  state?.orders?.refundOrders?.byId ?? {}

export const getNewRefundOrders = (state) =>
  getRefundOrders(state).filter((order) => !order.isPending)

export const getHistoryRefundOrders = (state) =>
  getRefundOrders(state).filter((order) => order.state !== 'completed')

export const getOrder = (state, id) => state?.orders?.allOrders?.byId[id]

export const getAllOrdersTotalCount = (state) =>
  state?.orders?.allOrders?.total ?? 0

export const getRefundMutations = (state) =>
  filter(getRefundOrders(state), (order) => order.isPending === true)

export const getIsLoadingRefundOrders = (state) =>
  state?.orders?.refundOrders?.isLoading

export const getAllOrders = (state) =>
  Object.values(state.orders?.allOrders.byId ?? {})

export const getIsAllOrdersLoading = (state) =>
  state.orders?.allOrders?.isLoading ?? false

export const getOrdersApiParamsConfig = (state) =>
  state?.orders?.allOrders?.paramsConfig ?? {}

export const getOrdersSearchFilters = (state) =>
  state?.orders?.allOrders?.filters?.searchBarWithSelect ?? {}

export const getRefundOrdersSearchQueryValue = (state) =>
  state?.orders?.refundOrders?.filters?.searchQuery ?? ''

export const getRefundOrdersFilteredByStartTime = (state) =>
  state?.orders?.refundOrders?.filters?.startTime ?? ''

export const getRefundOrdersFilteredByEndTime = (state) =>
  state?.orders?.refundOrders?.filters?.endTime ?? ''

export const getRefundOrdersFilteredByRevenueCenterUuid = (state) =>
  state?.orders?.refundOrders?.filters?.revenueCenterUuid ?? ''

export const getFilteredRefundOrders = createSelector(
  getRefundMutations,
  getRefundOrdersFilteredByRevenueCenterUuid,
  (refundOrders, revenueCenterUuid) => {
    const refundOrdersWithUpdatedState = refundOrders?.map((order) => {
      const updatedState = transformedPendingRefundState(order?.state)

      return { ...order, state: updatedState }
    })

    const ordersFilteredByRevenueCenters = (order) => {
      return revenueCenterUuid === order.standUuid
    }

    if (isEmpty(revenueCenterUuid)) return refundOrdersWithUpdatedState

    return refundOrdersWithUpdatedState?.filter((order) => {
      return ordersFilteredByRevenueCenters(order)
    })
  }
)

export const getPendingRefundDetails = (state, uuid) => {
  const refundOrders = Object.values(getRefundOrders(state))
  return refundOrders.find((refundOrder) => refundOrder.uuid === uuid)
}
